import React from "react";
import AuthHeader from "../components/common/Headers/NonLoginUserHeader/AuthHeader";
import { useLocation } from "react-router-dom";
// import routes from "../routing/router";
import UserFooter from "../components/common/Footer/UserFooter/UserFooter";

const AuthLayout = ({ children }) => {
  const location = useLocation();
  // const [isHide, setIsHide] = useState(false);

  // useEffect(() => {
  //   isShownFooter();
  // }, [location]);

  // const isShownFooter = () => {
  //   setIsHide(
  //     routes.filter((r) => r.path === location.pathname && r.isFooter).length >
  //       0
  //       ? true
  //       : false
  //   );
  // };

  window.scrollTo(0, 0);
  return (
    <div>
      <div>
        <AuthHeader />
      </div>
      <div>{children}</div>
      <UserFooter />
    </div>
  );
};

export default AuthLayout;
